module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/menu/powerpoint_icon-01f64e.png";